/**
 * Utility function to determine language based on CNPJ/EIN
 * 
 * Rule:
 * - CNPJ (14 digits, Brazilian format) → Portuguese
 * - EIN (9 digits, American format) → English
 * - Default → Portuguese
 */

export function getLanguageFromCnpjEin(cnpjEin) {
  if (!cnpjEin) return 'pt'; // Default: Portuguese
  
  // Remove non-numeric characters
  const numbersOnly = cnpjEin.replace(/\D/g, '');
  
  // CNPJ has 14 digits, EIN has 9 digits
  if (numbersOnly.length === 14) return 'pt'; // CNPJ = Portuguese
  if (numbersOnly.length === 9) return 'en';  // EIN = English
  
  // Check format: XX-XXXXXXX is EIN
  if (/^\d{2}-\d{7}$/.test(cnpjEin)) return 'en';
  
  // Check format: XX.XXX.XXX/XXXX-XX is CNPJ
  if (/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(cnpjEin)) return 'pt';
  
  return 'pt'; // Default: Portuguese
}

/**
 * Check if CNPJ/EIN is Brazilian (CNPJ)
 */
export function isCNPJ(cnpjEin) {
  return getLanguageFromCnpjEin(cnpjEin) === 'pt';
}

/**
 * Check if CNPJ/EIN is American (EIN)
 */
export function isEIN(cnpjEin) {
  return getLanguageFromCnpjEin(cnpjEin) === 'en';
}
